import { render, staticRenderFns } from "./Digression.vue?vue&type=template&id=0bc08a00&scoped=true&"
import script from "./Digression.vue?vue&type=script&lang=js&"
export * from "./Digression.vue?vue&type=script&lang=js&"
import style0 from "./Digression.vue?vue&type=style&index=0&id=0bc08a00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc08a00",
  null
  
)

export default component.exports